import { Component, Event, EventEmitter, Prop, h } from '@stencil/core';

@Component({
  tag: 'biel-search-header',
  styleUrl: 'biel-search-header.css',
  shadow: true,
})
export class BielSearchHeader {
  @Prop() placeholderText: string = 'Search or ask AI...';
  @Prop() hideFilters: boolean = true;
  @Prop() filters: { position: number; title: string; url: string }[] = [];
  @Prop() bielId: string;
  @Prop() searchQuery: string;

  @Event() closeSearchClicked: EventEmitter<{ bielId: string }>;

  handleCloseClick() {
    this.closeSearchClicked.emit({ bielId: this.bielId });
  }

  render() {
    return (
      <div class="biel-search-header">
        <div class="biel-search-header-container">
          <biel-search-input placeholderText={this.placeholderText}></biel-search-input>
          <button class="close-button" onClick={() => this.handleCloseClick()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-x"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
        </div>
        <div class="biel-search-header__filters-container">
          {!this.hideFilters && this.filters.length > 0 && this.searchQuery !== '' && (
            <biel-search-filters
              class="biel-search-header__filters"
              filters={this.filters}
            ></biel-search-filters>
          )}
        </div>
      </div>
    );
  }
}
